import React from 'react';
import TextField from '@material-ui/core/TextField';
import { OptionTypeBase } from 'react-select/src/types';
import { ControlProps } from 'react-select/src/components/Control';
import clsx from 'clsx';

const inputComponent = ({ inputRef, ...props }: { inputRef: React.LegacyRef<HTMLDivElement> }) => {
  return <div ref={inputRef} {...props} />;
};

export const Control = (props: ControlProps<OptionTypeBase, boolean>) => {
  const {
    children,
    innerProps,
    innerRef,
    selectProps: { classes, TextFieldProps, isDisabled },
  } = props;

  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        classes: { underline: classes.underline },
        inputProps: {
          className: clsx(classes.input, { [classes.disabledInput]: isDisabled }),
          ref: innerRef,
          children,
          ...innerProps,
        },
      }}
      {...TextFieldProps}
    />
  );
};
